import { Component, HostListener, Renderer2 } from "@angular/core";
import { Router } from "@angular/router";
import { CriteriUtente } from "../../../common/models/criteri-utente";
//aggiunta nuovo import
import { CriterioCustom } from "../../../common/models/criterio-custom";
import { SearchRequest } from "../../../common/models/dto/search-request";
import { Parte } from "../../../common/models/parte";
import { RicercaBean } from "../../../common/models/ricerca/ricerca-bean";
import { SearchCriteria } from "../../../common/models/search-criteria";
import { SmartCriteriRicerca } from "../../../common/models/smartCriteriRicerca";
import { StatoEntita } from "../../../common/models/tipologiche/stato-entita";
import { TipoAtto } from "../../../common/models/tipologiche/tipo-atto";
import { TipoPratica } from "../../../common/models/tipologiche/tipo-pratica";
import { SearchCacheService } from "../../../common/services/search.cache.service";
import { HelpersService } from "../../../core/services/helpers.service";
import { ServicesSearch } from "../../services/search.service";

//var cc: CriterioCustom  = new CriterioCustom();

@Component({
        selector: 'modale-ricerca',
    templateUrl: 'modale-ricerca.component.html'
})



export class modaleRicerca {
    classModale: {};
    ricercaBean: RicercaBean = new RicercaBean();
    showModal: boolean = false;
    searchText: string = "";
    request: SearchRequest = new SearchRequest();
    tipiPratica: TipoPratica[];
	statiPratica: StatoEntita[];
	tipiAtto: TipoAtto[];
	cognomeControparte:string[];

    constructor(private router: Router, private searchCacheService: SearchCacheService, private services: ServicesSearch, private helperServices: HelpersService, private renderer: Renderer2) { }

    ngOnInit() {
        this.loadTipiPratica();
        this.loadStatiPratica();
        this.loadTipiAtto();
      }

    @HostListener('window:keyup', ['$event'])


    keyEvent(event: KeyboardEvent) {
        if (event.keyCode == 113) {
            this.showModal = !this.showModal;
            this.searchText = "";
            console.log(this.router.url);
        }
        if(this.showModal == true){
        if(event.keyCode === 13) {
            this.cerca('pratica');
            this.router.navigate(['ricerca']);
            // setTimeout(() => { this.router.navigate(['ricerca/risultati']); }, 10);
        }
        if(event.keyCode === 32){
            document.getElementById("testoLibero").focus();
        }
    }
    }

    closeModal(){
        this.showModal = false;
    }


    cerca(tipo: string) {
        this.showModal = false;

        let request: SearchRequest = new SearchRequest();
        request.searchCriteria = new SearchCriteria();
        request.searchCriteria.searchText = this.searchText;

        if (tipo === "pratica") {
            request.includePratiche = true;
            request.includeDocuments = false;
        } else if (tipo === "documenti") {
            request.includePratiche = false;
            request.includeDocuments = true;
        }

        this.services.search(request).subscribe(response => {
            this.searchCacheService.lastSearch = null;
            this.ricercaBean.searchResponse = response;
            this.ricercaBean.onSearch = true;
            this.ricercaBean.listToggleOpened = new Array<number>();

            if (this.ricercaBean.searchResponse.returnCode === 'OK') {
                this.ricercaBean.searchRequest.searchCriteria.searchText = this.searchText;
                this.ricercaBean.searchRequest.fromResult = 0;
                this.ricercaBean.scrollDisabled = false;
                this.ricercaBean.searchRequest.nomeCampoOrdinamento = 'posizioneOrd.keyword';
                this.ricercaBean.searchRequest.asc = false;
                this.ricercaBean.actionOrdinamento = 'posizioneOrdDesc';
                if (tipo === "pratica") {
                    this.ricercaBean.resultPratica = true;
                    this.ricercaBean.resultDocumento = false;
                    this.ricercaBean.searchRequest.includePratiche = true;
                    this.ricercaBean.searchRequest.includeDocuments = false;
                } else {
                    this.ricercaBean.resultPratica = false;
                    this.ricercaBean.resultDocumento = true;
                    this.ricercaBean.searchRequest.includePratiche = false;
                    this.ricercaBean.searchRequest.includeDocuments = true;
                }
                this.ricercaBean.openContainer = false;
                this.ricercaBean.enableContainerInteraction = true;
                this.searchCacheService.lastSearch = this.ricercaBean;
                this.router.navigate(['ricerca']);
                // setTimeout(() => { this.router.navigate(['ricerca/risultati']); }, 10);
            }

        });

    }

    smartSearch(){
        this.showModal = false;

        this.services.smartSearch(this.searchText).subscribe(response => {

            this.ricercaBean.searchRequest = new SearchRequest();
			this.ricercaBean.searchRequest.asc = false;
			this.ricercaBean.searchRequest.includiFaccette = true;


			this.ricercaBean.searchRequest.searchCriteria = new SearchCriteria();

			//check pratiche e documenti sostituibilie con if else
			if(response.smartCriteriRicerca.includePratiche == "true") {
				this.ricercaBean.searchRequest.includeDocuments = false;
				this.ricercaBean.searchRequest.includePratiche = true;
			}

			if(response.smartCriteriRicerca.includeDocuments == "true") {
				this.ricercaBean.searchRequest.includeDocuments = true;
				this.ricercaBean.searchRequest.includePratiche = false;

			}



			//------------------------- INIZIO SEZIONE CRITERI CUSTOM ------------------------

			this.ricercaBean.searchRequest.searchCriteria.criteriUtente = new CriteriUtente();
			this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom = {};
			if(response.smartCriteriRicerca.annoruolo != "" && response.smartCriteriRicerca.annoruolo != null) {
				let cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "string";
				//cc.order = 2;
				cc.selected = false;
				cc.uid = 'annoRuolo';
				cc.label = 'Anno Ruolo';
				cc.labelGruppo = 'Ruolo';
				cc.widthPercentage = 50;
				cc.value = response.smartCriteriRicerca.annoruolo;
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom['annoRuolo'] = cc;
			}

			if(response.smartCriteriRicerca.numeroruolo != "" && response.smartCriteriRicerca.numeroruolo != null) {
				var cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "string";
				//cc.order = 1;
				cc.selected = false;
				cc.uid = "numeroRuolo";
				cc.label = "Numero Ruolo";
				cc.labelGruppo = "Ruolo";
				cc.widthPercentage = 50;
				cc.value = response.smartCriteriRicerca.numeroruolo;
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom["numeroRuolo"] = cc;

			}


			if(response.smartCriteriRicerca.naturafascicolo != "" && response.smartCriteriRicerca.naturafascicolo != null){
                var cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "combo";
				cc.lovUrl = "/rs/hlp/gp/tipinatura";
				//cc.order = 3;
				cc.selected = false;
				cc.uid = "naturaFascicolo";
				cc.label = "Natura Fascicolo";
				cc.widthPercentage = 50;
				if(response.smartCriteriRicerca.naturafascicolo.toLowerCase()=="attivo") {
					cc.value = "1";
				}
				else if(response.smartCriteriRicerca.naturafascicolo.toLowerCase()=="passivo") {
					cc.value = "2";
				}
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom["naturaFascicolo"] = cc;
	        }


		if(response.smartCriteriRicerca.tipodocumento != "" && response.smartCriteriRicerca.tipodocumento != null) {
			let cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "combo";
				//cc.order = 1;
				cc.lovUrl = '/rs/hlp/gp/tipiatto';
				cc.selected = false;
				cc.uid = 'tipoAtto';
				cc.label = 'Tipo atto';
				cc.labelGruppo = 'Atto';
				cc.widthPercentage = 50;
				this.tipiAtto.forEach(item =>{
                    if((item.label).toLowerCase() == (response.smartCriteriRicerca.tipodocumento).toLowerCase()){
                        cc.value = item.id;
                    }
                });
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom['tipoAtto'] = cc;
			}

			if(response.smartCriteriRicerca.Numprotocollo != "" && response.smartCriteriRicerca.Numprotocollo != null) {
				let cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "string";
				//cc.order = 1;
				cc.selected = false;
				cc.uid = 'numProtocollo';
				cc.label = 'Numero Protocollo';
				cc.labelGruppo = 'Atto';
				cc.widthPercentage = 50;
				cc.value = response.smartCriteriRicerca.Numprotocollo ;
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom['numProtocollo'] = cc;
			}

			if(response.smartCriteriRicerca.Provenienza != "" && response.smartCriteriRicerca.Provenienza != null) {
				let cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "combo";
				//cc.order = 1;
				cc.lovUrl = '/rs/hlp/gp/tipiprovenienze';
				cc.selected = false;
				cc.uid = 'provenienza';
				cc.label = 'Provenienza';
				cc.labelGruppo = 'Atto';
				cc.widthPercentage = 50;
				if(response.smartCriteriRicerca.Provenienza.toLowerCase()=="interno") {
					cc.value = "1";
				}
				else if(response.smartCriteriRicerca.Provenienza.toLowerCase()=="esterno") {
					cc.value = "2";
				}
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom['provenienza'] = cc;
			}

			if(response.smartCriteriRicerca.Datanotificaattoda != "" && response.smartCriteriRicerca.Datanotificaattoda!= null) {
				let cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "data";
				//cc.order = 1;
				cc.selected = false;
				cc.uid = 'dataNotificaAttoDa';
				cc.label = 'Data notifica da';
				cc.labelGruppo = 'Atto';
				cc.widthPercentage = 50;
				cc.value = response.smartCriteriRicerca.Datanotificaattoda; //da verifcare nella richiesta originale questo valore viene passato come num
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom['dataNotificaAttoDa'] = cc;
            }

            if(response.smartCriteriRicerca.Datanotificaattoa != "" && response.smartCriteriRicerca.Datanotificaattoa!= null) {
				let cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "data";
				//cc.order = 1;
				cc.selected = false;
				cc.uid = 'dataNotificaAttoA';
				cc.label = 'Data notifica a';
				cc.labelGruppo = 'Atto';
				cc.widthPercentage = 50;
				cc.value = response.smartCriteriRicerca.Datanotificaattoa; //da verifcare nella richiesta originale questo valore viene passato come num
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom['dataNotificaAttoA'] = cc;
            }

            if(response.smartCriteriRicerca.Datadepositoattoda != "" && response.smartCriteriRicerca.Datadepositoattoda!= null) {
				let cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "data";
				//cc.order = 1;
				cc.selected = false;
				cc.uid = 'dataDepositoAttoDa';
				cc.label = 'Data deposito da';
				cc.labelGruppo = 'Atto';
				cc.widthPercentage = 50;
				cc.value = response.smartCriteriRicerca.Datadepositoattoda; //da verifcare nella richiesta originale questo valore viene passato come num
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom['dataDepositoAttoDa'] = cc;
            }

            if(response.smartCriteriRicerca.Datadepositoattoa != "" && response.smartCriteriRicerca.Datadepositoattoa!= null) {
				let cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "data";
				//cc.order = 1;
				cc.selected = false;
				cc.uid = 'dataDepositoAttoA';
				cc.label = 'Data deposito a';
				cc.labelGruppo = 'Atto';
				cc.widthPercentage = 50;
				cc.value = response.smartCriteriRicerca.Datadepositoattoa; //da verifcare nella richiesta originale questo valore viene passato come num
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom['dataDepositoAttoA'] = cc;
            }

            if(response.smartCriteriRicerca.Tipoesito != "" && response.smartCriteriRicerca.Tipoesito != null) {
				let cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "combo";
				//cc.order = 2;
                cc.selected = false;
                cc.lovUrl = '/rs/hlp/gp/tipiesito';
				cc.uid = 'tipoEsito';
				cc.label = 'Tipo esito';
				cc.labelGruppo = 'Esito';
				cc.widthPercentage = 50;
				switch(response.smartCriteriRicerca.Tipoesito.toLowerCase()) {
					case "sentenza": {
						cc.value = "1";
						break;
					}
					case "ordinanza": {
						cc.value = "2";
						break;
					}
					case "decreto": {
						cc.value = "3";
						break;
					}
					case "dispositivo": {
						cc.value = "4";
						break;
					}
					case "transazione": {
						cc.value = "5";
						break;
					}
					case "accordo": {
						cc.value = "6";
						break;
					}
				}
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom['tipoEsito'] = cc;
            }

            if(response.smartCriteriRicerca.Numeroesito != "" && response.smartCriteriRicerca.Numeroesito != null) {
				let cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "string";
				//cc.order = 2;
                cc.selected = false;
				cc.uid = 'numeroEsito';
				cc.label = 'Numero';
				cc.labelGruppo = 'Esito';
				cc.widthPercentage = 50;
				cc.value = response.smartCriteriRicerca.Numeroesito;
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom['numeroEsito'] = cc;
            }

            if(response.smartCriteriRicerca.Annoesito != "" && response.smartCriteriRicerca.Annoesito != null) {
				let cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "string";
				//cc.order = 2;
                cc.selected = false;
				cc.uid = 'annoEsito';
				cc.label = 'Anno';
				cc.labelGruppo = 'Esito';
				cc.widthPercentage = 50;
				cc.value = response.smartCriteriRicerca.Annoesito;
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom['annoEsito'] = cc;
            }

            if(response.smartCriteriRicerca.Datadepositoesitoda != "" && response.smartCriteriRicerca.Datadepositoesitoda!= null) {
				let cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "data";
				//cc.order = 1;
				cc.selected = false;
				cc.uid = 'dataDepositoEsitoDa';
				cc.label = 'Data deposito da';
				cc.labelGruppo = 'Esito';
				cc.widthPercentage = 50;
				cc.value = response.smartCriteriRicerca.Datadepositoesitoda; //da verifcare nella richiesta originale questo valore viene passato come num
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom['dataDepositoEsitoDa'] = cc;
            }

            if(response.smartCriteriRicerca.Datadepositoesitoa != "" && response.smartCriteriRicerca.Datadepositoesitoa!= null) {
				let cc: CriterioCustom  = new CriterioCustom();
				cc.dataType = "data";
				//cc.order = 1;
				cc.selected = false;
				cc.uid = 'dataDepositoEsitoA';
				cc.label = 'Data deposito a';
				cc.labelGruppo = 'Esito';
				cc.widthPercentage = 50;
				cc.value = response.smartCriteriRicerca.Datadepositoesitoa; //da verifcare nella richiesta originale questo valore viene passato come num
				this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom['dataDepositoEsitoA'] = cc;
			}

			//if(Object.keys(this.ricercaBean.searchRequest.searchCriteria.criteriUtente.criteriCustom).length == 0) {
			//	this.ricercaBean.searchRequest.searchCriteria.criteriUtente=null;
			//}

			//------------------------- FINE SEZIONE CRITERI CUSTOM ------------------------




            if(response.smartCriteriRicerca.dataFine != "" && response.smartCriteriRicerca.dataFine != null){
                this.ricercaBean.searchRequest.searchCriteria.inizioFascicoloDataA = this.formatDate(response.smartCriteriRicerca.dataFine);
            }

            if(response.smartCriteriRicerca.dataInizio!= "" && response.smartCriteriRicerca.dataInizio != null){
                this.ricercaBean.searchRequest.searchCriteria.inizioFascicoloDataDa = this.formatDate(response.smartCriteriRicerca.dataInizio);
            }

            if(response.smartCriteriRicerca.cognome != "" && response.smartCriteriRicerca.cognome != null){
                this.ricercaBean.searchRequest.searchCriteria.parte = new Parte();
                this.ricercaBean.searchRequest.searchCriteria.parte.cognome = response.smartCriteriRicerca.cognome;
            }

            if(response.smartCriteriRicerca.statopratica != "" && response.smartCriteriRicerca.statopratica != null){
                this.ricercaBean.searchRequest.searchCriteria.statoPratica = new StatoEntita();
                this.statiPratica.forEach(item =>{
                    if((item.label).toLowerCase() == (response.smartCriteriRicerca.statopratica).toLowerCase()){
                        this.ricercaBean.searchRequest.searchCriteria.statoPratica = item;
                    }
                });
            }

            if(response.smartCriteriRicerca.tipopratica != "" && response.smartCriteriRicerca.tipopratica != null){
                this.ricercaBean.searchRequest.searchCriteria.tipoPratica = new TipoPratica();
                this.tipiPratica.forEach(item =>{
                    if((item.label).toLowerCase() == (response.smartCriteriRicerca.tipopratica).toLowerCase()){
                        this.ricercaBean.searchRequest.searchCriteria.tipoPratica = item;
                    }
                });
            }
			this.ricerca(this.ricercaBean, response.smartCriteriRicerca);


        });
    }

    formatDate(dataString){

        let data = new Date(dataString);
        return  data.getTime();

    }

    ricerca(request: RicercaBean, smartCriteriRicerca: SmartCriteriRicerca){

        this.services.search(request.searchRequest).subscribe(response => {
            this.ricercaBean.searchResponse = response;
            this.ricercaBean.onSearch = true;
            this.ricercaBean.listToggleOpened = new Array<number>();
			this.ricercaBean.searchResponse.searchCriteria.listaSmart = new SmartCriteriRicerca();
			this.ricercaBean.searchResponse.searchCriteria.listaSmart = smartCriteriRicerca;

			console.log(this.ricercaBean.searchResponse.searchCriteria.listaSmart)
			console.log(this.ricercaBean.searchResponse.searchCriteria.listaSmart.cognome);

            if (this.ricercaBean.searchResponse.returnCode === 'OK') {
				console.log("RICERCA return code ok")
                this.ricercaBean.searchRequest.searchCriteria.searchText = this.searchText;
                this.ricercaBean.searchRequest.fromResult = 0;
                this.ricercaBean.scrollDisabled = false;
                this.ricercaBean.searchRequest.nomeCampoOrdinamento = 'posizioneOrd.keyword';
                this.ricercaBean.searchRequest.asc = false;
                this.ricercaBean.actionOrdinamento = 'posizioneOrdDesc';
                //if (tipo === "pratica") {
					if(request.searchRequest.includePratiche==true) {
                    this.ricercaBean.resultPratica = true;
					this.ricercaBean.resultDocumento = false;
					} else {
						this.ricercaBean.resultPratica = false;
					this.ricercaBean.resultDocumento = true;
					}
                //} else {
                //    this.ricercaBean.resultPratica = false;
                //    this.ricercaBean.resultDocumento = true;
                //}
                this.ricercaBean.openContainer = false;
				this.ricercaBean.enableContainerInteraction = true;
				console.log("ricerca modale");
				console.log(this.ricercaBean);

                this.searchCacheService.lastSearch = this.ricercaBean; //<- questo "associa" i campi dalla ricerca all'html "LastSearch"
                this.router.navigate(['ricerca']);
                // setTimeout(() => { this.router.navigate(['ricerca/risultati']); }, 10);
            }

        });
    }

    loadTipiPratica() {
        this.helperServices.getTipiPraticaSearch().subscribe(response => this.tipiPratica = response.sort((leftSide, rigthSide): number => {
            if (leftSide.label < rigthSide.label) return -1;
            if (leftSide.label > rigthSide.label) return 1;
            return 0;
          }));
    }

    loadStatiPratica() {
        this.helperServices.getStatiPratica().subscribe(response => this.statiPratica = response.sort((leftSide, rigthSide): number => {
            if (leftSide.label < rigthSide.label) return -1;
            if (leftSide.label > rigthSide.label) return 1;
            return 0;
          }));
	}

	loadTipiAtto() {
        this.helperServices.getTipiAtto().subscribe(response => this.tipiAtto = response.sort((leftSide, rigthSide): number => {
            if (leftSide.label < rigthSide.label) return -1;
            if (leftSide.label > rigthSide.label) return 1;
            return 0;
          }));
    }




}
